import { ThunkResult } from '../../store'
import palletApi from '../../apis/pallet.api'
import palletService from '../../services/pallet.service'
import { replaceResult, replaceResultData } from './Receivings.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().receivings
    const params = { page, limit, search }
    palletApi.paginateReceivings(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deleteReceiving (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    palletApi.delete(id, pallet => {
      if (!pallet) return
      const { result } = getState().receivings
      const data = palletService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
